import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogDescription, DialogTitle } from "src/components/base/dialog";
import { Button } from "src/components/base/button";
import { ApiInternal } from "src/api/api_internal";
import { UUID } from "src/api/api_common";

/**
 * The properties for {@link DisableSubnetDialog}
 */
export type DisableSubnetDialogProps = {
    /** Callback for closing the popup */
    onClose: () => void;

    /** Callback for successful disable */
    onDisable: () => void;

    /** The subnet */
    subnet: {
        /** Name of the subnet */
        name: string;
        /** UUID of the subnet */
        uuid: UUID;
    };
};

/**
 * Dialog to disable a given subnet
 */
export default function DisableSubnetDialog(props: DisableSubnetDialogProps) {
    const [t] = useTranslation("dialog-disable-subnet");
    const [tg] = useTranslation();

    /**
     * Disable an existing subnet
     */
    const disableSubnet = async () => {
        await ApiInternal.subnets.disable(props.subnet.uuid);
        props.onDisable();
    };

    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle>{t("heading.disable-subnet", { subnet: props.subnet.name })}</DialogTitle>
            <DialogDescription>{t("description.disable-subnet")}</DialogDescription>
            <DialogActions>
                <Button onClick={props.onClose}>{tg("button.cancel")}</Button>
                <Button color={"red"} onClick={async () => await disableSubnet()}>
                    {t("button.disable-subnet")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
